//Accounting Menu Options

import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";

export const ChartOfAccountsMenuFlag = () => {
  return useFeatureFlag("Chart_of_Accounts_Menu");
};

export const BankTransactionsMenuFlag = () => {
  return useFeatureFlag("Bank_Transactions");
};

export const ConnectedBankAccountsMenuFlag = () => {
  return useFeatureFlag("Connected_Bank_Accounts");
};

export const BatchChargesMenuFlag = () => {
  return useFeatureFlag("Batch_Charges_Menu");
};

export const CompanyFinancialsMenuFlag = () => {
  return useFeatureFlag("Bank_Transactions");
};

export const DisputesMenuFlag = () => {
  return true;
};

export const AddConnectedBankAccountFlag = () => {
  return useFeatureFlag("Add_Connected_Bank_Account");
};
